import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/app-check';

const firebaseApp = firebase.initializeApp({
  apiKey: process.env.REACT_APP_F_APIKEY,
  authDomain: 'bienesmart.in',
  databaseURL: 'https://bienes-mart.firebaseio.com',
  projectId: 'bienes-mart',
  storageBucket: 'bienes-mart.appspot.com',
  messagingSenderId: process.env.REACT_APP_F_MSID,
  appId: process.env.REACT_APP_F_APPID,
  measurementId: process.env.REACT_APP_F_MID,
});
const appCheck = firebaseApp.appCheck();
appCheck.activate('6LdwpwscAAAAAOHdiQ2Dj_3qTHuAoeX4kDlhAYtS', true);
const db = firebaseApp.firestore();
const cCustomers = 'customers';
const cProducts = 'products';
const fieldValue = firebase.firestore.FieldValue;
const storage = firebase.storage();
const ga = firebase.analytics();
const auth = firebase.auth();
const providerGoogle = new firebase.auth.GoogleAuthProvider();

export {cCustomers, cProducts, fieldValue, storage, ga, auth, providerGoogle};
export default db;
